if (typeof PNotify !== "undefined") {
	// Set top offset of default stack to be roughly the same as the first panel
	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	PNotify.prototype.options.stack.firstpos1 = 93;
}

export class Notify {

	public static success(message: string): PNotify {
		return this.notify(message, "bg-success");
	}

	public static info(message: string): PNotify {
		return this.notify(message, "bg-info");
	}

	public static warning(message: string): PNotify {
		return this.notify(message, "bg-warning");
	}

	public static danger(message: string): PNotify {
		return this.notify(message, "bg-danger");
	}

	private static notify(message?: string, clazz?: string): PNotify {
		return new PNotify({
			text: message,
			addclass: clazz || "bg-info",
			delay: 2000,
			buttons: {
				sticker: false
			}
		});
	}
}
